type Props = {
  className?: string
}

export const IconCircle = ({ className }: Props) => {
  return (
    <svg
      className={className}
      fill="none"
      height="24"
      viewBox="0 0 25 24"
      width="25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3395_7792)">
        <path
          d="M23.5 4V10H17.5"
          stroke="#09909E"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <path
          d="M20.9899 15C20.3398 16.8399 19.1094 18.4187 17.484 19.4985C15.8586 20.5783 13.9263 21.1006 11.9783 20.9866C10.0303 20.8726 8.17203 20.1286 6.68363 18.8667C5.19524 17.6047 4.1573 15.8932 3.72625 13.9901C3.29519 12.0869 3.49436 10.0952 4.29374 8.31508C5.09313 6.53496 6.44942 5.06288 8.15823 4.12065C9.86705 3.17843 11.8358 2.81711 13.7678 3.09116C15.6999 3.3652 17.4905 4.25975 18.8699 5.64001L23.4999 10"
          stroke="#09909E"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
      </g>
      <defs>
        <clipPath id="clip0_3395_7792">
          <rect
            fill="white"
            height="24"
            transform="translate(0.5)"
            width="24"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
